<template>
  <div class="mask" @click.prevent.stop="stop" v-if="$store.state.networkError">
    <div class="title">
      当前网络已断开，请检查该设备的网络环境！
    </div>
    <div>
      <img :src="wldk" alt="" />
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        wldk:require('@/assets/image/index/wldk.png'),
      }
    },
    methods:{
      stop(){}
    }
  }
</script>

<style scoped>
  .mask{
    position: fixed;
    background-color: rgba(0, 0, 0, .6);
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
  }
  .title{
    font-size: 24px;
    color: #fff;
    line-height: 80px;
    margin-top: 30vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/networkErrorMask.vue